module.exports = "/_next/static/images/qa-b39ab9d65d692399d4d1ffe1dde78371.svg";